export default "__VITE_ASSET__A2Bl1o8W__"